import { render, staticRenderFns } from "./CoinNetworkFeatureTag.vue?vue&type=template&id=f0d75f46&scoped=true&"
import script from "./CoinNetworkFeatureTag.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkFeatureTag.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkFeatureTag.vue?vue&type=style&index=0&id=f0d75f46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d75f46",
  null
  
)

export default component.exports